import { take, all, fork, cancel, call } from 'redux-saga/effects'
import { isFunction } from 'lodash-es'

/**
 * Wait for an event to happen (action to be dispatched),
 * but also handle if the event already happened in the past.
 * @param waitList Array of arrays, while each inner array has the following structure:
 * [hasEventAlreadyHappened, ...list of actions, one of them will unblock the event]
 * usually hasEventAlreadyHappened will be a result of a state selector (data is already fetched),
 * list of actions will be two actions, a success and a failure of a fetching event
 * @returns {IterableIterator<*>}
 */
function* waitFor(waitList) {
  const actionsToWait = []

  waitList.forEach((waitItem) => {
    const [readyState, ...oneOfActions] = waitItem

    if (!readyState) {
      actionsToWait.push(take(oneOfActions))
    }
  })

  if (actionsToWait.length > 1) {
    yield all(actionsToWait)
  } else {
    yield actionsToWait[0]
  }
}

function* handleInitAndLeave(
  watchers,
  initAction,
  leaveAction,
  beforeLeaveHandler
) {
  const tasks = []

  while (true) {
    const action = yield take(initAction)

    // TODO (noahlaux): Refactor as we can't yield inside an array iteration

    for (const watcher of watchers) {
      tasks.push(yield fork(watcher, action))
    }

    yield take(leaveAction)
    if (isFunction(beforeLeaveHandler)) {
      yield call(beforeLeaveHandler)
    }
    yield tasks.map((task) => cancel(task))
  }
}

function exportSagas(watchers, initAction, leaveAction, beforeLeaveHandler) {
  return [
    () =>
      handleInitAndLeave(watchers, initAction, leaveAction, beforeLeaveHandler),
  ]
}

const yieldSagasGenerator = (sagas) => {
  return function* yieldSagas() {
    yield sagas
  }
}

export { waitFor, exportSagas, yieldSagasGenerator }
